import { render, staticRenderFns } from "./TransformingDataList.vue?vue&type=template&id=663bf225&scoped=true"
import script from "./TransformingDataList.vue?vue&type=script&lang=js"
export * from "./TransformingDataList.vue?vue&type=script&lang=js"
import style0 from "./TransformingDataList.vue?vue&type=style&index=0&id=663bf225&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "663bf225",
  null
  
)

export default component.exports